module.exports = "images/franceinfo.637abcd4.png";